export enum LogLevel {
	debug = 1000,
	info = 2000,
	warn = 3000,
	error = 4000,
}
